import {interactionDurationMetrics} from "@/app/utils/InteractionMetrics";
import {CustomInlineTool} from "@/dashboards/widgets/commentaryplus/inlineTools/CustomInlineTool";

export class CountInlineTool extends CustomInlineTool {

    getBtnOptions() {
        return countBtnOptions;
    }

    getBtnName() {
        return "Count";
    }

    toolTipText() {
        return "Add a count metric";
    }

}

export const countBtnOptions = [
    ...interactionDurationMetrics.flatMap(({command, label}) => [
        {text: `Average ${label}`, command: `{{total ${command}}}`},
        {text: `Median ${label}`, command: `{{total median-${command}}}`}
    ]),
    {
        text: "Mentions",
        command: "{{total mentions}}"
    },
    {
        text: "Verified mentions",
        command: "{{total mentions 'process is verified'}}"
    },
    {
        text: "Public sentiment",
        command: "{{total public-net%}}"
    },
    {
        text: "Benchmark sentiment",
        command: "{{total benchmark-net%}}"
    },
    {
        text: "Net sentiment",
        command: "{{total net}}"
    },
    {
        text: "Net sentiment%",
        command: "{{total net%}}"
    },
    {
        text: "Negative sentiment",
        command: "{{total negative}}"
    },
    {
        text: "Neutral sentiment",
        command: "{{total neutral}}"
    },
    {
        text: "Positive sentiment",
        command: "{{total positive}}"
    },
    {
        text: "Unique authors",
        command: "{{total authors}}"
    },
    {
        text: "Unique sources",
        command: "{{total sites}}"
    },
    {
        text: "Engagement",
        command: "{{total engagement}}"
    },
    {
        text: "OTS",
        command: "{{total ots}}"
    },
    {
        text: "CX %",
        command: "{{cx%}}"
    },
    {
        text: "CX Reshare%",
        command: "{{cx-reshare%}}"
    },
    {
        text: "Purchase%",
        command: "{{cx-purchase%}}"
    },
    {
        text: "Cancel%",
        command: "{{cx-cancel%}}"
    },
    {
        text: "Nps Total",
        command: "{{nps-total}}"
    },
    {
        text: "Nps Score",
        command: "{{nps-score}}"
    },
    {
        text: "Nps Detractors",
        command: "{{nps-detractors}}"
    },
    {
        text: "Nps Passives",
        command: "{{nps-passives}}"
    },
    {
        text: "Nps Promoters",
        command: "{{nps-promoters}}"
    },
    {
        text: "Csat Total",
        command: "{{csat-total}}"
    },
    {
        text: "Csat Score",
        command: "{{csat-score}}"
    },
    {
        text: "Ces5 Total",
        command: "{{ces5-total}}"
    },
    {
        text: "Ces5 Score",
        command: "{{ces5-score}}"
    },
    {
        text: "Fcr Total",
        command: "{{fcr-total}}"
    },
    {
        text: "Fcr Score",
        command: "{{fcr-score}}"
    },
    {
        text: "Average Nps Rating",
        command: "{{ave-nps}}"
    },
    {
        text: "Average Csat Rating",
        command: "{{ave-csat}}"
    },
    {
        text: "Average Custom Question Rating",
        command: "{{ave-ten-point-custom}}"
    },
    {
        text: "Average 10 point custom score",
        command: "{{ave-ten-point-custom}}"
    },
    {
        text: "Engage Tickets",
        command: "{{engage-tickets}}"
    },
    {
        text: "Platform impressions",
        command: "{{platform-impressions}}"
    },
    {
        text: "Platform engagement",
        command: "{{platform-engagement}}"
    },
    {
        text: "Platform reactions",
        command: "{{platform-reactions}}"
    },
    {
        text: "Platform reshares",
        command: "{{platform-reshares}}"
    },
    {
        text: "Platform comment",
        command: "{{platform-comment}}"
    },
    {
        text: "Platform video views",
        command: "{{platform-video-views}}"
    },
    {
        text: "Ticket milestone status: Closed",
        command: "{{ticket-milestone-status-closed}}"
    },
    {
        text: "Ticket milestone status: Pending",
        command: "{{ticket-milestone-status-pending}}"
    },
    {
        text: "Ticket priority: Risk",
        command: "{{ticket-priority-risk}}"
    },
    {
        text: "Ticket priority: Service",
        command: "{{ticket-priority-service}}"
    },
    {
        text: "Ticket priority: Purchase",
        command: "{{ticket-priority-purchase}}"
    },
    {
        text: "Ticket priority: Cancel",
        command: "{{ticket-priority-cancel}}"
    },
    {
        text: "Ad Spend",
        command: "{{ad-spend}}"
    },
    {
        text: "Ad CPC",
        command: "{{ad-cpc}}"
    },
    {
        text: "Ad CPM",
        command: "{{ad-cpm}}"
    },
    {
        text: "Ad Cost per Page Engagement",
        command: "{{ad-cost-per-page-engagement}}"
    },
    {
        text: "Ad Cost per Post Engagement",
        command: "{{ad-cost-per-post-engagement}}"
    },
    {
        text: "Ad Cost per Link Click",
        command: "{{ad-cost-per-link-click}}"
    },
    {
        text: "Ad Clicks",
        command: "{{ad-clicks}}"
    },
    {
        text: "Ad CTR",
        command: "{{ad-ctr}}"
    },
    {
        text: "Ad Outbound Clicks",
        command: "{{ad-outbound-clicks}}"
    },
    {
        text: "Ad Outbound CTR",
        command: "{{ad-outbound-clicks-ctr}}"
    },
    {
        text: "Ad Link Clicks",
        command: "{{ad-inline-link-clicks}}"
    },
    {
        text: "Ad Link CTR",
        command: "{{ad-inline-link-click-ctr}}"
    },
    {
        text: "Ad Impressions",
        command: "{{ad-impressions}}"
    },
    {
        text: "Ad Frequency",
        command: "{{ad-frequency}}"
    },
    {
        text: "Ad Reach",
        command: "{{ad-reach}}"
    },
];
